import { PaginationParams, PaginationResponse } from 'models/pagination'

export const MplusStatus = {
  waiting: 'waiting',
  ready: 'ready',
  error: 'error',
} as const
export type MplusStatus = (typeof MplusStatus)[keyof typeof MplusStatus]

export const MplusServiceType = {
  mplus: 'mplus',
  murabaha: 'murabaha',
  adal: 'adal',
} as const
export type MplusServiceType =
  (typeof MplusServiceType)[keyof typeof MplusServiceType]

export type MplusObject = {
  id: number
  created_at: string
  consultant: {
    full_name: string
    type_division: string
    main_branch: string
    branches: string
    phone: string
    inn: string
  }
  service_type: MplusServiceType
  status: MplusStatus
  inn: string
  phone: string
  name: string
  point_name: string
  filial: {
    id: number
    name: string
  }
  activities: {
    id: number
    name: string
    murabaha: boolean
  }
  full_address: string
}

export interface GetMplusListResponse
  extends PaginationResponse<
    Pick<
      MplusObject,
      | 'id'
      | 'inn'
      | 'name'
      | 'status'
      | 'service_type'
      | 'full_address'
      | 'created_at'
    >
  > {
  created_at: string
}

export interface GetMplusParams extends PaginationParams {
  search?: string
  status?: string
  start_date?: string
  end_date?: string
  supervisor?: string
}
